import { Typography, styled } from '@mui/material'
import { Link } from 'react-router-dom'
import { FAIRTRADE_FONT_STACK } from '../../constants'

export const BubbleList = styled('div')<{ withArrows?: boolean }>(
  ({ theme, withArrows }) => `
  padding: 15px ${!withArrows ? '30px' : '0'} ${theme.spacing(1.25)};
  width: 85vw;
  overflow-x: auto;
  overflow-y: none;
  &::-webkit-scrollbar {
    width: 0.5em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  display: flex;
  gap: 16px;
  align-items: center;
  font-family: ${FAIRTRADE_FONT_STACK};
`,
)

// Pick readable text colour for a given bubble background.
// Light bubbles (e.g. Leaf Green #D4FF47) need dark text; the saturated
// purple/pink stay readable on white.
const pickBubbleTextColor = (bubbleColor: string) => {
  const hex = bubbleColor.replace('#', '')
  if (hex.length !== 6) return '#ffffff'
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#111111' : '#ffffff'
}

// Three different bubble shapes using CSS shape() function
const getBubbleShape = (shapeIndex: number) => {
  switch (shapeIndex) {
    case 0:
      // First shape
      return `
        aspect-ratio: 1;
        clip-path: shape(from 48.62% 12.07%,curve to 84.19% 35.07% with 70.23% 18.12%,curve to 82.99% 68.06% with 98.16% 52.02%,curve to 45.52% 88.16% with 67.83% 84.10%,curve to 18.10% 70.33% with 23.21% 92.21%,curve to 20.00% 27.24% with 12.99% 48.45%,curve to 48.62% 12.07% with 27.01% 6.03%);
      `
    case 1:
      // Second shape
      return `
        aspect-ratio: 1;
        clip-path: shape(from 40.07% 13.68%,curve to 66.96% 23.72% with 56.47% 16.10%,curve to 87.40% 45.18% with 77.46% 31.34%,curve to 85.92% 72.53% with 97.34% 59.03%,curve to 59.14% 84.30% with 74.49% 86.04%,curve to 30.23% 77.61% with 43.79% 82.56%,curve to 14.80% 57.79% with 16.66% 72.65%,curve to 18.30% 27.09% with 12.93% 42.93%,curve to 40.07% 13.68% with 23.67% 11.26%);
      `
    case 2:
      // Third shape
      return `
        aspect-ratio: 1;
        clip-path: shape(from 87.58% 32.44%,curve to 86.42% 66.40% with 90.05% 50.00%,curve to 66.40% 89.89% with 82.79% 82.79%,curve to 37.08% 86.42% with 50.00% 96.99%,curve to 12.76% 62.92% with 24.16% 75.84%,curve to 11.69% 36.01% with 1.35% 50.00%,curve to 36.01% 14.13% with 22.02% 22.02%,curve to 67.56% 10.56% with 50.00% 6.24%,curve to 87.58% 32.44% with 85.12% 14.88%);
      `
    default:
      return ''
  }
}

export const BubbleCard = styled(Link, {
  shouldForwardProp: (prop) =>
    prop !== 'disabled' && prop !== 'bubbleColor' && prop !== 'shapeIndex',
})<{
  disabled?: boolean
  bubbleColor: string
  shapeIndex: number
}>(
  ({ disabled, bubbleColor, shapeIndex }) => `
  position: relative;
  width: 250px;
  min-width: 250px;
  height: 250px;
  background-color: ${bubbleColor};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: ${pickBubbleTextColor(bubbleColor)};
  transition: transform 200ms, filter 200ms;
  will-change: transform, filter;
  flex-shrink: 0;
  margin-left: -35px;
  margin-right: -20px;
  
  ${getBubbleShape(shapeIndex)}
  
  &:hover {
    filter: ${disabled ? '' : 'brightness(90%)'};
    transform: ${disabled ? '' : 'scale(0.98)'};
  }
`,
)

export const BubbleContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* padding: 24px 32px; */
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: border-box;
`

export const BubbleTitle = styled(Typography)`
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 6px;
  color: inherit;
  font-family: inherit;
  text-align: center;
  word-break: break-word;
  max-width: 100%;
  padding: 0 60px;
`

export const BubbleSubtitle = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: inherit;
  font-family: inherit;
  word-break: break-word;
  text-align: center;
  max-width: 100%;
  padding: 0 60px;

`

